import request from '@/utils/request'

// 公司信息相关 API
export function getCompany() {
  return request({
    url: '/api/index/getCompany',
    method: 'post'
  })
}

export function getLeaders() {
  return request({
    url: '/api/index/getLeaders',
    method: 'post'
  })
}

export function getPartners() {
  return request({
    url: '/api/index/getPartners',
    method: 'post'
  })
}

// 其他 API...
export function getProducts() {
  return request({
    url: '/api/index/getProducts',
    method: 'post'
  })
}

export function getNews() {
  return request({
    url: '/api/index/getNews',
    method: 'post'
  })
}

// 统一的 POST 请求方法
export function postRequest(url, data = {}) {
  return request({
    url,
    method: 'post',
    data
  })
}

// 统一的 GET 请求方法
export function getRequest(url, params = {}) {
  return request({
    url,
    method: 'get',
    params
  })
}